import { useState, useEffect } from 'react';
import { Review } from '../types/review';
import { ReviewService } from '../services/reviewService';

export const useReviews = (udprn?: string) => {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchReviews = async () => {
    setLoading(true);
    setError(null);
    
    try {
      let data: Review[];
      if (udprn) {
        data = await ReviewService.getReviewsByUdprn(udprn);
      } else {
        data = await ReviewService.getAllReviews();
      }
      setReviews(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch reviews');
      console.error('Error fetching reviews:', err);
    } finally {
      setLoading(false);
    }
  };

  const addReview = (newReview: Review) => {
    setReviews(prev => [newReview, ...prev]);
  };

  useEffect(() => {
    fetchReviews();
  }, [udprn]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    reviews,
    loading,
    error,
    refetch: fetchReviews,
    addReview
  };
};